var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.136 1A4.14 4.14 0 0 0 1 5.136v5.728A4.14 4.14 0 0 0 5.136 15h5.728A4.14 4.14 0 0 0 15 10.864V5.136A4.14 4.14 0 0 0 10.864 1H5.136zM12.5 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0z",
  clipRule: "evenodd"
})));
export default SvgInstagram;